/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  GamoraFoundationAdapterQuery,
  GamoraFoundationAdapterQueryArgs,
  GamoraFoundationAdapterQueryOperator,
} from '../query.js';
import { GamoraUUIDGuard } from '../../../guards/uuid.js';

/**
 * @public
 */
export type GamoraFoundationAdapterQueryLockOperand = [
  string,
  GamoraUUIDGuard,
  number,
];

/**
 * @public
 */
export type GamoraFoundationAdapterQueryLockResult = boolean;

/**
 * @public
 */
export type GamoraFoundationAdapterQueryLockArgs =
  GamoraFoundationAdapterQueryArgs<GamoraFoundationAdapterQueryLockOperand>;

/**
 * @public
 */
export class GamoraFoundationAdapterQueryLock extends GamoraFoundationAdapterQuery<
  GamoraFoundationAdapterQueryLockOperand,
  GamoraFoundationAdapterQueryLockResult
> {
  protected override _operator: GamoraFoundationAdapterQueryOperator =
    GamoraFoundationAdapterQueryOperator.LOCK;
  constructor(args: GamoraFoundationAdapterQueryLockArgs) {
    super(args);
  }

  /**
   * Constructs query
   * @param operand The operand
   */
  static override fromOperand(
    operand: GamoraFoundationAdapterQueryLockOperand,
    options?: any,
  ): GamoraFoundationAdapterQueryLock {
    return new GamoraFoundationAdapterQueryLock({
      operand,
      options,
    });
  }
}
